import apiFetch from '@wordpress/api-fetch';
import { __ } from "@wordpress/i18n";
import { useEffect, useState } from 'react';
import Hint from '../components/Hint/Hint';
import Switch from '../components/Switch/Switch';
import { useMenu } from '../contexts/MenuContext';
import { formDataPost } from "../helpers/Helpers"; // Import utility function
import withForm from '../pages/withForm';
const SecurityComments = ({handleChange}) => {
    const {
        settingData
    } = useMenu();

    const [selectedFilter, setSelectedFilter] = useState("general");
    const [reload, setReload] = useState(0);
    const filters = [
        { general: "General" },
        { 'comments-cleaner': "Comments Cleaner" },
    ];
    const postType = [
        { value: "All", code: "all" },
        { value: "Posts", code: "post" },
        { value: "Pages", code: "page" },
        { value: "Media", code: "attachment" },
    ];
    const [selectedPostType, setSelectedPostType] = useState({
        all: false,
        post: false,
        page: false,
        attachment: false
    });

    const [commentsReload, setCommentsReload] = useState(0); 
     
    const [commentsCount, setCommentsCount] = useState(null);   
    const [deleteCommentsCount, setDeleteCommentsCount] = useState(0)  
    useEffect(() => {
        const fetchComments = async () => {
            try {
                const results = await apiFetch({
                    path: "/ultimate-security/v1/get-comments-count",
                    method: "GET"
                });
        
                const allCount = (results.post || 0) + (results.page || 0) + (results.attachment || 0); // + (data.product || 0)
        
                // Update state with the new object including 'all' key
                setCommentsCount({ ...results, all: allCount });
            } catch (error) {
                console.error("Error fetching histories:", error);
            }
        };
        fetchComments();
    }, [reload]);

    useEffect(()=> {
        const allCount = (selectedPostType?.post? commentsCount?.post?commentsCount?.post: 0 : 0) + (selectedPostType?.page? commentsCount?.page?commentsCount?.page: 0  : 0) + (selectedPostType?.attachment? commentsCount?.attachment?commentsCount?.attachment: 0  : 0)
        setDeleteCommentsCount(allCount)
    },[selectedPostType])
      
    
    const handleAllClickPostType = (isChecked) => {
        // const isChecked = e.target.checked;
        setSelectedPostType({
            all: isChecked,
            post: isChecked,
            page: isChecked,
            attachment: isChecked
        });        
    };
    
    const handleSingleClickPostType = (code) => (e) => {
        const isChecked = e.target.checked;
        const newSelected = {
            ...selectedPostType,
            [code]: isChecked
        };
    
        // Check if all options except "all" are selected
        const allOthersSelected = postType
        .filter(type => type.code !== 'all')
        .every(type => newSelected[type.code]);    
        // Update the "all" checkbox based on other selections
        newSelected.all = allOthersSelected;
    
        setSelectedPostType(newSelected);
    };
    const handleClick = (isChecked, code) => {
        if (code == 'all') {
            setSelectedPostType({
                all: isChecked,
                post: isChecked,
                page: isChecked,
                attachment: isChecked
            }); 
        }
        else {
            const newSelected = {
                ...selectedPostType,
                [code]: isChecked
            };
          
            // Check if all options except "all" are selected
            const allOthersSelected = postType
            .filter(type => type.code !== 'all')
            .every(type => newSelected[type.code]);
        
            // Update the "all" checkbox based on other selections
            newSelected.all = allOthersSelected;
        
            setSelectedPostType(newSelected);
        }

    }

    const [removeAllProcessing, setRemoveAllProcessing] = useState(false)
    const [removeAllProcessingRing, setRemoveAllProcessingRing] = useState(false)
    const [removeAllProcessingTick, setRemoveAllProcessingTick] = useState(false)
    const removeAllComments = async () => {
        const confirmed = window.confirm(__('Are you sure you want to proceed?', 'ultimate-security'));
        if (confirmed) {

            const selectedTypesString = Object.keys(selectedPostType)
            .filter(key => selectedPostType[key] === true && key !== 'all')
            .join(',');            
            setRemoveAllProcessing(true);
            setRemoveAllProcessingRing(true);          
            try {
                const result = await formDataPost('ultimate_security_remove_comments_by_post_type',{"type": selectedTypesString}); 
                if(result.success_message) {
                    setRemoveAllProcessingRing(false);
                    setRemoveAllProcessingTick(true)
                    setCommentsReload(Math.random)
                    setSelectedPostType({
                        all: false,
                        post: false,
                        page: false,
                        attachment: false
                    })
                    setReload(Math.random)
                    setTimeout(()=> {
                        setRemoveAllProcessingTick(false)
                        setRemoveAllProcessing(false)
                    },1000)
                }
                setRemoveAllProcessing(false);
                setRemoveAllProcessingRing(false); 
                
            } catch (error) {
                console.log(error);
                setRemoveAllProcessing(false);
                setRemoveAllProcessingRing(false); 
            }
        }      
    }  

    const [removeSpamCommentsProcessing, setRemoveSpamCommentsProcessing] = useState(false)
    const [removeSpamCommentsProcessingRing, setRemoveSpamCommentsProcessingRing] = useState(false);
    const [removeSpamCommentsProcessingTick, setRemoveSpamCommentsProcessingTick] = useState(false);
    const removeSpamComments = async () => {
        const confirmed = window.confirm(__('Are you sure you want to proceed?', 'ultimate-security'));
        if (confirmed) {
            setRemoveSpamCommentsProcessing(true);
            setRemoveSpamCommentsProcessingRing(true);  
            try {
                const result = await formDataPost('ultimate_security_remove_comments',{"type": 'spam'}); 
                if(result.success_message) {
                    setRemoveSpamCommentsProcessingRing(false);
                    setRemoveSpamCommentsProcessingTick(true)
                    setCommentsReload(Math.random)
                    setSelectedPostType({
                        all: false,
                        post: false,
                        page: false,
                        attachment: false
                    })
                    setReload(Math.random)
                    setTimeout(()=> {
                        setRemoveSpamCommentsProcessingTick(false)
                        setRemoveSpamCommentsProcessing(false)
                    },1000)
                }
                setRemoveSpamCommentsProcessing(false);
                setRemoveSpamCommentsProcessingRing(false); 
                
            } catch (error) {
                console.log(error);
                setRemoveSpamCommentsProcessing(false);
                setRemoveSpamCommentsProcessingRing(false); 
            }
        }      
    } 

    const [removePendingCommentsProcessing, setRemovePendingCommentsProcessing] = useState(false)
    const [removePendingCommentsProcessingRing, setRemovePendingCommentsProcessingRing] = useState(false);
    const [removePendingCommentsProcessingTick, setRemovePendingCommentsProcessingTick] = useState(false);
    const removePendingComments = async () => {
        const confirmed = window.confirm(__('Are you sure you want to proceed?', 'ultimate-security'));
        if (confirmed) {
            setRemovePendingCommentsProcessing(true);
            setRemovePendingCommentsProcessingRing(true);  
            try {
                const result = await formDataPost('ultimate_security_remove_comments',{"type": 'pending'}); 
                console.log(result);
                if(result.success_message) {
                    setRemovePendingCommentsProcessingRing(false);
                    setRemovePendingCommentsProcessingTick(true)
                    setCommentsReload(Math.random)
                    setSelectedPostType({
                        all: false,
                        post: false,
                        page: false,
                        attachment: false
                    })
                    setReload(Math.random)
                    setTimeout(()=> {
                        setRemovePendingCommentsProcessingTick(false)
                        setRemovePendingCommentsProcessing(false)
                    },1000)
                }
                setRemovePendingCommentsProcessing(false);
                setRemovePendingCommentsProcessingRing(false); 
                
            } catch (error) {
                console.log(error);
                setRemovePendingCommentsProcessing(false);
                setRemovePendingCommentsProcessingRing(false); 
            }
        }      
    }
    
    const [removeTrashedCommentsProcessing, setRemoveTrashedCommentsProcessing] = useState(false)
    const [removeTrashedCommentsProcessingRing, setRemoveTrashedCommentsProcessingRing] = useState(false);
    const [removeTrashedCommentsProcessingTick, setRemoveTrashedCommentsProcessingTick] = useState(false);
    const removeTrashedComments = async () => {
        const confirmed = window.confirm(__('Are you sure you want to proceed?', 'ultimate-security'));
        if (confirmed) {
            setRemoveTrashedCommentsProcessing(true);
            setRemoveTrashedCommentsProcessingRing(true);  
            try {
                const result = await formDataPost('ultimate_security_remove_comments',{"type": 'trash'}); 
                if(result.success_message) {
                    setRemoveTrashedCommentsProcessingRing(false);
                    setRemoveTrashedCommentsProcessingTick(true)
                    setCommentsReload(Math.random)
                    setSelectedPostType({
                        all: false,
                        post: false,
                        page: false,
                        attachment: false
                    })
                    setReload(Math.random)
                    setTimeout(()=> {
                        setRemoveTrashedCommentsProcessingTick(false)
                        setRemoveTrashedCommentsProcessing(false)
                    },1000)
                }
                setRemoveTrashedCommentsProcessing(false);
                setRemoveTrashedCommentsProcessingRing(false); 
                
            } catch (error) {
                console.log(error);
                setRemoveTrashedCommentsProcessing(false);
                setRemoveTrashedCommentsProcessingRing(false); 
            }
        }      
    } 
    return (
        <>
            <div className="setting-unit">
                <div className="d-flex align-items-center justify-content-center">
                    <div className="filter-wrapper background-purple-10">
                        {filters && filters.length && 
                            filters.map((filter, index) => {
                                return (
                                <button
                                    key={index}
                                    className={`filter-btn pl-heading-2 ${
                                        selectedFilter === Object.keys(filter)[0]
                                        ? "active"
                                        : ""
                                    }`}
                                    onClick={() =>
                                        setSelectedFilter(Object.keys(filter)[0])
                                    }
                                >
                                    <span>{Object.values(filter)[0]}</span>
                                </button>
                                );
                            })
                        }
                    </div>
                </div>
            </div>
            {
                selectedFilter === "general" &&
                <>
                    <div className="setting-unit pt-lg mt-lg border-top">
                        <div className="row">
                            <div className="col-lg-5">
                                <div className="title-group">
                                    <h5 className="pl-heading-1 fw-600 text-text">{__("Global Comments", "ultimate-security")}</h5>
                                    <p className="pl-body text-text">{__("You can disable comments globally, even for old posts. You can also choose which post types you want to enable/disable comments for.", "ultimate-security")}</p>
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="row justify-content-between">
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("No Hint", "ultimate-security")}/>
                                            <h6 className="pl-heading-1 fw-600 text-text">{__("Disable comments", "ultimate-security")}</h6>                                            
                                        </div>
                                        <div className="content-below-with-hint">
                                            <select 
                                                className="form-select"
                                                value={settingData?.security?.comments?.disable_comments} 
                                                onChange={(e) => handleChange('security.comments.disable_comments', e.target.value)}
                                            >
                                                <option value="enable_comments">{__("Not disable", "ultimate-security")}</option>
                                                <option value="custom_post_type">{__("On certain post types", "ultimate-security")}</option>
                                                <option value="disable_comments">{__("Everywhere", "ultimate-security")}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        settingData?.security?.comments?.disable_comments === 'custom_post_type' && 
                        <div className="setting-unit pt-lg mt-lg border-top">
                            <div className="row">
                                <div className="col-lg-5">
                                    <div className="title-group">
                                        <h5 className="pl-heading-1 fw-600 text-text">{__("Select post types", "ultimate-security")}</h5>
                                        <p className="pl-body text-text">{__("Two-factor authentication provides users with an additional layer of security by requiring a second authentication method beyond their email address and password. It is one of the most effective ways to prevent account theft.", "ultimate-security")}</p>
                                    </div>
                                </div>
                                <div className="col-lg-7">
                                    
                                    <div className="row justify-content-between">
                                        <div className="col-lg-10">
                                            <div className="title-group d-flex align-items-center ">
                                                <Hint content={__("Enable/disable for posts", "ultimate-security")}/>
                                                <h6 className="pl-heading-1 fw-600 text-text">{__("Posts", "ultimate-security")}</h6>
                                            </div>
                                        </div>                            
                                        <div className="col-auto">
                                            <Switch 
                                                name="security.comments.disable_comments_post_types_post"
                                                checked={settingData?.security?.comments?.disable_comments_post_types_post} // Pass "1"/"0" from API 
                                                onChange={handleChange} 
                                            />
                                        </div>
                                    </div>
                                    <div className="row justify-content-between">
                                        <div className="col-lg-10">
                                            <div className="title-group d-flex align-items-center ">
                                                <Hint content={__("Enable/disable for page", "ultimate-security")}/>
                                                <h6 className="pl-heading-1 fw-600 text-text">{__("Pages", "ultimate-security")}</h6>
                                            </div>
                                        </div>                            
                                        <div className="col-auto">
                                            <Switch 
                                                name="security.comments.disable_comments_post_types_page"
                                                checked={settingData?.security?.comments?.disable_comments_post_types_page} // Pass "1"/"0" from API 
                                                onChange={handleChange} 
                                            />
                                        </div>
                                    </div>
                                    <div className="row justify-content-between">
                                        <div className="col-lg-10">
                                            <div className="title-group d-flex align-items-center ">
                                                <Hint content={__("Enable/disable for media", "ultimate-security")}/>
                                                <h6 className="pl-heading-1 fw-600 text-text">{__("Media", "ultimate-security")}</h6>
                                            </div>
                                        </div>                            
                                        <div className="col-auto">
                                            <Switch 
                                                name="security.comments.disable_comments_post_types_attachment"
                                                checked={settingData?.security?.comments?.disable_comments_post_types_attachment} // Pass "1"/"0" from API 
                                                onChange={handleChange} 
                                            />
                                        </div>
                                    </div>
                                    <div className="row justify-content-between">
                                        <div className="col-lg-10">
                                            <div className="title-group d-flex align-items-center ">
                                                <Hint content={__("Enable/disable for products", "ultimate-security")}/>
                                                <h6 className="pl-heading-1 fw-600 text-text">{__("Products", "ultimate-security")}</h6>
                                            </div>
                                        </div>                            
                                        <div className="col-auto">
                                            <Switch 
                                                name="security.comments.disable_comments_post_types_product"
                                                checked={settingData?.security?.comments?.disable_comments_post_types_product} // Pass "1"/"0" from API 
                                                onChange={handleChange} 
                                            />
                                        </div>
                                    </div>
    
                                </div>
                            </div>
                        </div>
                    }

                    <div className="setting-unit pt-lg mt-lg border-top">
                        <div className="row">
                            <div className="col-lg-5">
                                <div className="title-group">
                                    <h5 className="pl-heading-1 fw-600 text-text">{__("Activate two factor authentication", "ultimate-security")}</h5>
                                    <p className="pl-body text-text">{__("Two-factor authentication provides users with an additional layer of security by requiring a second authentication method beyond their email address and password. It is one of the most effective ways to prevent account theft.", "ultimate-security")}</p>
                                </div>
                            </div>
                            <div className="col-lg-7">
                                
                                <div className="row justify-content-between">
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("Enable/disable according to requirements", "ultimate-security")}/>
                                            <h6 className="pl-heading-1 fw-600 text-text">{__("Remove \"site\" in the comment form", "ultimate-security")}</h6>
                                        </div>
                                    </div>                            
                                    <div className="col-auto">
                                        <Switch 
                                            name="security.comments.remove_url_field"
                                            checked={settingData?.security?.comments?.remove_url_field} // Pass "1"/"0" from API 
                                            onChange={handleChange} 
                                        />
                                    </div>
                                </div>
                                <div className="row justify-content-between">
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("Enable/disable according to requirements", "ultimate-security")}/>
                                            <h6 className="pl-heading-1 fw-600 text-text">{__("Remove external links in the comments", "ultimate-security")}</h6>
                                        </div>
                                    </div>                            
                                    <div className="col-auto">
                                        <Switch 
                                            name="security.comments.remove_url_from_comment"
                                            checked={settingData?.security?.comments?.remove_url_from_comment} // Pass "1"/"0" from API 
                                            onChange={handleChange} 
                                        />
                                    </div>
                                </div>
                                <div className="row justify-content-between">
                                    <div className="col-lg-10">
                                        <div className="title-group d-flex align-items-center ">
                                            <Hint content={__("Enable/disable according to requirements", "ultimate-security")}/>
                                            <h6 className="pl-heading-1 fw-600 text-text">{__("Replace external links from authors bio", "ultimate-security")}</h6>
                                        </div>
                                    </div>                            
                                    <div className="col-auto">
                                        <Switch 
                                            name="security.comments.remove_url_from_author_name"
                                            checked={settingData?.security?.comments?.remove_url_from_author_name} // Pass "1"/"0" from API 
                                            onChange={handleChange} 
                                        />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </>
            }
            {
                selectedFilter === "comments-cleaner" &&
                <>
                    <div className="setting-unit pt-lg mt-lg border-top">
                        <div className="row">
                            <div className="col-lg-5">
                                <div className="title-group">
                                    <h5 className="pl-heading-1 fw-600 text-text">{__("Remove all comments", "ultimate-security")}</h5>
                                    <p className="pl-body text-text">{__("Delete all comments in your database.", "ultimate-security")}</p>
                                </div>
                            </div>
                            <div className="col-lg-7">
                                {
                                    postType && postType.length && postType.map((data, index) => {
                                        return (
                                            <div key={data.code} className="row justify-content-between">
                                                <div className="col-lg-10">
                                                    <div className="title-group d-flex align-items-center ">
                                                        <Hint content={__("Enable/disable according to your requirement.", "ultimate-security")}/>
                                                        <h6 className="pl-heading-1 fw-600 text-text">
                                                            {data.value} 
                                                            ({commentsCount?.[data.code]?commentsCount?.[data.code]:0})
                                                        </h6>
                                                    </div>
                                                </div>                            
                                                <div className="col-auto">
                                                    <Switch 
                                                        name="security.comments.remove_url_field"
                                                        checked={selectedPostType[data.code]} // Pass "1"/"0" from API 
                                                        onChange={() => handleClick(!selectedPostType[data.code], data.code)}
                                                        data-code={data.code}
                                                    />
                                                </div>
                                            </div>
                                        );
                                    })
                                }
                                <div className="d-flex align-items-center gap-2 mt-3">                                    
                                    <button 
                                        type="button" 
                                        className="button button-primary" 
                                        onClick={removeAllComments}
                                        disabled={removeAllProcessing}
                                    >
                                        {
                                            removeAllProcessing ? __( "Processing...", "ultimate-security" ) : (__( "Delete", "ultimate-security" ) + ' (' + deleteCommentsCount + ')')
                                        }
                                    </button>
                                    {removeAllProcessingRing && <span className="lds-ring"><span></span><span></span><span></span><span></span></span>}
                                    {removeAllProcessingTick && <img src={ultimate_security_ajax_obj.imageUrl+'success-tick.svg'}/>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="setting-unit pt-lg mt-lg border-top">
                        <div className="row">
                            <div className="col-lg-5">
                                <div className="title-group">
                                    <h5 className="pl-heading-1 fw-600 text-text">{__("Remove spam comments", "ultimate-security")}</h5>
                                    <p className="pl-body text-text">{__("Delete spam comments in your database.", "ultimate-security")}</p>
                                </div>
                            </div>
                            <div className="col-lg-7">
                                
                                <div className="d-flex align-items-center gap-2">                                    
                                    <button 
                                        type="button" 
                                        className="button button-primary" 
                                        onClick={removeSpamComments}
                                        disabled={removeSpamCommentsProcessing}
                                    >
                                        {
                                            removeSpamCommentsProcessing ? __( "Processing...", "ultimate-security" ) : (__( "Delete", "ultimate-security" ) + ' (' + commentsCount?.spam + ')')
                                        }
                                    </button>
                                    {removeSpamCommentsProcessingRing && <span className="lds-ring"><span></span><span></span><span></span><span></span></span>}
                                    {removeSpamCommentsProcessingTick && <img src={ultimate_security_ajax_obj.imageUrl+'success-tick.svg'}/>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="setting-unit pt-lg mt-lg border-top">
                        <div className="row">
                            <div className="col-lg-5">
                                <div className="title-group">
                                    <h5 className="pl-heading-1 fw-600 text-text">{__("Remove unapproved comments", "ultimate-security")}</h5>
                                    <p className="pl-body text-text">{__("Delete unapproved comments in your database.", "ultimate-security")}</p>
                                </div>
                            </div>
                            <div className="col-lg-7">
                                
                                <div className="d-flex align-items-center gap-2">                                    
                                    <button 
                                        type="button" 
                                        className="button button-primary" 
                                        onClick={removePendingComments}
                                        disabled={removePendingCommentsProcessing}
                                    >
                                        {
                                            removePendingCommentsProcessing ? __( "Processing...", "ultimate-security" ) : (__( "Delete", "ultimate-security" ) + ' (' + commentsCount?.pending + ')')
                                        }
                                    </button>
                                    {removePendingCommentsProcessingRing && <span className="lds-ring"><span></span><span></span><span></span><span></span></span>}
                                    {removePendingCommentsProcessingTick && <img src={ultimate_security_ajax_obj.imageUrl+'success-tick.svg'}/>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="setting-unit pt-lg mt-lg border-top">
                        <div className="row">
                            <div className="col-lg-5">
                                <div className="title-group">
                                    <h5 className="pl-heading-1 fw-600 text-text">{__("Remove trashed comments", "ultimate-security")}</h5>
                                    <p className="pl-body text-text">{__("Delete trashed comments in your database.", "ultimate-security")}</p>
                                </div>
                            </div>
                            <div className="col-lg-7">                                
                                <div className="d-flex align-items-center gap-2">                                    
                                    <button 
                                        type="button" 
                                        className="button button-primary" 
                                        onClick={removeTrashedComments}
                                        disabled={removeTrashedCommentsProcessing}
                                    >
                                        {
                                            removeTrashedCommentsProcessing ? __( "Processing...", "ultimate-security" ) : (__( "Delete", "ultimate-security" ) + ' (' + commentsCount?.trash + ')')
                                        }
                                    </button>
                                    {removeTrashedCommentsProcessingRing && <span className="lds-ring"><span></span><span></span><span></span><span></span></span>}
                                    {removeTrashedCommentsProcessingTick && <img src={ultimate_security_ajax_obj.imageUrl+'success-tick.svg'}/>}
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
        </>
    )
}
export default withForm(SecurityComments, 'security.comments');